import { TRIGGER_METADATA_FOR_START_TILE } from '../../StartNodeEditor.constants';
import { useStartNodeContext } from '../../StartNodeEditor.context';

/**
 * Useful for grabbing additional data needed to populate fields
 * @returns {object} An object containing TriggerMetadata and resourceFieldValue
 */
export const useGetEntrySourceMetadata = () => {
  const { nodeData } = useStartNodeContext();

  const entrySourceMetadata = TRIGGER_METADATA_FOR_START_TILE[nodeData?.nodeClass] || {};
  const { resourceFieldName } = entrySourceMetadata;
  const resourceFieldValue = resourceFieldName ? nodeData[resourceFieldName] : undefined;

  return {
    ...entrySourceMetadata,
    // stringifying value to ensure autofocus works correctly with our selects
    ...(resourceFieldValue && { resourceFieldValue: `${resourceFieldValue}` }),
  };
};
